import styled, { css } from 'styled-components';

export const Container = styled.footer`
	padding: 40px;
	/* background-color: #fff; */
	background-color: #02734A;
	margin-top: 20px;
	width: 100%;
	cursor: default;
`;

export const Item = styled.div`
	display: flex;
	flex-direction: column;

	h3 {
		color: #000000;
		font-weight: bold;
		font-size: 1rem;
		margin-bottom: 7px;
	}

	a {
		color: #fff;
		border-bottom: 2px solid transparent;
		width: max-content;
		margin-bottom: 2px;
		transition: border-bottom 150ms ease-in-out;
		text-decoration: none;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 100%;

		&:hover {
			border-bottom: 2px solid #59A8D9;
			transition: border-bottom 150ms ease-in-out;
		}
	}
`;

export const FollowUs = styled.div`
	margin-top: 15px;
	display: flex;
	justify-content: flex-start;
	align-items: center;

	a {
		color: #55595c;
		color: #fff;
		transition: color 150ms ease-in-out;
		text-decoration: none;
		cursor: pointer;
		border: none !important;

		& + a {
			margin-left: 10px;
		}

		&:hover {
			transition: color 150ms ease-in-out;
			color: #fdae45;
		}
	}
`;

export const ImgLink = styled.a`
	margin-right: 10px;
	height: 25px;
	min-height: 100px;
	max-height: 25px;
	width: 100px;
	min-width: 100px;
	max-width: 100px;
	margin: 0 !important;
	overflow: hidden;

	${({ img: { src, size, position } }) => css`
		background-image: url(${src});
		background-repeat: no-repeat;
		background-position: ${position || 'center center'};
		background-size: ${size};
	`}
`;
